/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/entry/add-jira-vendor-imports
import '@jira/platform__vendor/src/vendor-parcel.tsx';
import '@jira/platform__vendor/src/commons-parcel.tsx';

import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getSpaRoutes } from '@jira/platform__routes/src/getSpaRoutes.tsx';
import { startJiraSpa } from './start-jira-spa.tsx';

setMark('JIRA_SPA_ENTRY_LOADED');

startJiraSpa(getSpaRoutes);
